import Colors from './Colors';
import Config from './Config';
import Locales from './Locales';
import Screens from './Screens';

export const MOVEMENT_EVENTS = ['move_event', 'knockback_event', 'death', 'unit_spawned'];

export { Colors, Config, Locales, Screens };

export const DISCORD_URL = 'https://discord.gg/dungeonteam'; // 'https://discord.gg/ysgHx3ErwJ';
